import script from "./AgentBulkActionMenu.windows.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentBulkActionMenu.windows.vue?vue&type=script&setup=true&lang=ts"

import "./AgentBulkActionMenu.windows.vue?vue&type=style&index=0&id=380b5238&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380b5238"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
